import { useState } from 'react'
import { useIntl } from '@/intl'

export const useTexts = () => {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    title: translate({ id: 'errorPage.generic.title' }),
    description: translate({ id: 'errorPage.generic.description' }),
    primaryAction: translate({ id: 'errorPage.generic.primaryAction' }),
    secondaryAction: translate({ id: 'errorPage.generic.secondaryAction' }),
  }))

  return api
}
